import React, { useEffect, useState, Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Download, Star, Sparkles, Clock } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 20,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          minutes,
          seconds
        } = prev;
        seconds -= 1;
        if (seconds < 0) {
          seconds = 59;
          minutes -= 1;
        }
        if (minutes < 0) {
          minutes = 0;
          seconds = 0;
        }
        return {
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  const scrollToPurchase = () => {
    document.getElementById('elegir')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.4
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    show: {
      opacity: 1,
      x: 0,
      transition: {
        type: 'spring',
        stiffness: 100
      }
    }
  };
  return <section className="relative pt-8 pb-16 lg:pt-12 lg:pb-20 overflow-visible px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-89">
      <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-2xl flex flex-col items-center text-center lg:items-start lg:text-left" data-id="element-91">
          <img src="https://cdn.magicpatterns.com/uploads/csnKSKWxgJ7EjkLSDSPn4V/LOGO_DECOEMPRENDE.png" alt="Deco Emprende" className="h-12 sm:h-14 object-contain mb-8 opacity-90" data-id="element-92" />
          <h1 className="text-4xl sm:text-5xl lg:text-6xl leading-[1.2] mb-6 text-brand-text font-serif font-bold" data-id="element-93">
            Aprendé{' '}
            <span className="relative inline-block" data-id="element-94">
              <span className="font-script text-6xl sm:text-7xl lg:text-8xl text-brand-cta font-normal -rotate-2 inline-block drop-shadow-sm px-1" data-id="element-95">
                Tricotín
              </span>
              <svg className="absolute w-full h-3 -bottom-1 left-0 text-brand-pink/60" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-96">
                <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="3" fill="transparent" strokeLinecap="round" data-id="element-97" />
              </svg>
            </span>{' '}
            <br className="hidden sm:block" data-id="element-98" />
            desde cero con guía paso a paso + plantillas listas para crear
          </h1>

          <p className="text-base sm:text-lg lg:text-xl text-brand-text/70 font-medium mb-8 leading-relaxed max-w-xl" data-id="element-99">
            Creá nombres, flores, souvenirs y piezas personalizadas para regalar
            o vender, aunque nunca hayas hecho tricotín antes.
          </p>

          <motion.div variants={containerVariants} initial="hidden" animate="show" className="flex flex-col gap-3 sm:gap-4 mb-8 w-full max-w-md mx-auto lg:mx-0" data-id="element-100">
            {[{
            icon: Star,
            text: 'Ideal para emprender'
          }, {
            icon: Download,
            text: 'Descarga inmediata'
          }, {
            icon: CheckCircle2,
            text: 'Kit completo'
          }].map((bullet, i) => <motion.div key={i} variants={itemVariants} className="flex items-center gap-3 sm:gap-4 bg-white/60 backdrop-blur-sm p-3 sm:p-4 rounded-2xl border border-brand-sand/60 shadow-sm hover:shadow-md transition-shadow" data-id="element-101">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-brand-pink/30 flex items-center justify-center text-brand-cta shrink-0" data-id="element-102">
                  <bullet.icon size={20} className="sm:w-6 sm:h-6" data-id="element-103" />
                </div>
                <span className="text-brand-text font-semibold text-sm sm:text-base text-left" data-id="element-104">
                  {bullet.text}
                </span>
              </motion.div>)}
          </motion.div>

          <motion.div whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} animate={{
          y: [0, -4, 0]
        }} transition={{
          y: {
            duration: 2.5,
            repeat: Infinity,
            ease: 'easeInOut'
          }
        }} className="w-full sm:w-auto rounded-full" data-id="element-105">
            <Button onClick={scrollToPurchase} className="w-full sm:w-auto text-base sm:text-lg px-8 py-4 sm:px-12 sm:py-5 shadow-[0_8px_20px_rgba(216,154,137,0.3)] hover:shadow-[0_12px_25px_rgba(201,121,101,0.4)] rounded-full bg-brand-cta text-white font-bold transition-all border-2 border-brand-cta/20 hover:bg-brand-cta-hover" data-id="element-106">
              QUIERO SABER MÁS
            </Button>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative mt-4 lg:mt-0 px-2 sm:px-0" data-id="element-107">
          <div className="relative rounded-[2rem] sm:rounded-[2.5rem] overflow-hidden shadow-2xl bg-brand-card aspect-[4/5] sm:aspect-[3/4] lg:aspect-[4/5] flex items-center justify-center p-1.5 sm:p-2 border-4 sm:border-8 border-white max-w-sm sm:max-w-md mx-auto" data-id="element-108">
            <video src="https://cdn.magicpatterns.com/uploads/rGWgLGvxRcvakmSyJnCp3o/WhatsApp Video 2026-05-30 at 01.22.09.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover rounded-[1.5rem] sm:rounded-[2rem]" data-id="element-109" />
          </div>
        </motion.div>
      </div>
    </section>;
}